import { render, staticRenderFns } from "./AuditLogStatusColumn.vue?vue&type=template&id=63f61a8c&scoped=true"
import script from "./AuditLogStatusColumn.vue?vue&type=script&lang=ts"
export * from "./AuditLogStatusColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f61a8c",
  null
  
)

export default component.exports